export { Header } from './components/Header/Header';
export { HowItWorks } from './components/HowItWorks';
export { FeaturedProducts } from './components/FeaturedProducts';
export { MoreProducts } from './components/MoreProducts';
export { Support } from './components/Support';
export { LogoBanner } from './components/LogoBanner';
export { DesignConsultationBanner } from './components/DesignConsultationBanner';
export { getProductsByKey } from './graph/getProductsByKey';
export { getFeaturedCareProducts } from './products';

export { Header as RedesignHeader } from './components/redesignComponents/Header/Header';
export { BrandBanner } from './components/redesignComponents/BrandBanner';
export { SupportBanner } from './components/redesignComponents/SupportBanner';
export { FAQ } from './components/redesignComponents/FAQ';
export { HowItWorks as RedesignHowItWorks } from './components/redesignComponents/HowItWorks';
export { WhyHireOnVistaprint } from './components/redesignComponents/WhyHireOnVistaprint';
export { StickyNav } from './components/redesignComponents/StickyNav';
export {
    DesignCategories,
    useCategoriesConfig,
} from './components/redesignComponents/DesignCategories';
export { VistaValueProposition } from './components/redesignComponents/VistaValueProposition';
export { PackagingSampleBanner } from './components/redesignComponents/PackagingSampleBanner';
export {
    PopularProducts,
    popularProductKeys,
} from './components/redesignComponents/PopularProducts';

export { designProducts, getDesignProducts } from './products/';
export {
    NewDesignProductPresenter,
    getDesignProductPresenters,
} from './products/productsPresenter';
export { PackagingDesignBanner } from './components/redesignComponents/PackagingDesignBanner/PackagingDesignBanner';
export { PackagingDoubleBanner } from './components/redesignComponents/PackagingDoubleBanner/PackagingDoubleBanner';

export type { FeaturedProductsType } from './graph/getProductsByKey';
export type {
    DesignProductPresenter,
    ProductImage,
    ProductImageOptions,
    VistaDesignProduct,
    BifrostDesignProduct,
    NNDesignProduct,
    DesignProduct,
    CloudinaryImage,
    ExternalImage,
    ProductKey,
} from './products/types';
